import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: 'bg-primary-100/80 hover:bg-primary-100',
    text: 'text-primary-700',
    iconBg: 'bg-primary-500',
  },
  accent: {
    bg: 'bg-accent-100/80 hover:bg-accent-100',
    text: 'text-accent-700',
    iconBg: 'bg-accent-500',
  },
  secondary: {
    bg: 'bg-secondary-100/80 hover:bg-secondary-100',
    text: 'text-secondary-700',
    iconBg: 'bg-secondary-500',
  },
};

export default function CategorySection() {
  return (
    <section className="py-16 md:py-22 bg-background-50">
      <div className="container-site">
        <div className="text-center mb-12">
          <span className="inline-block text-sm font-medium text-primary-600 bg-primary-100/70 px-3 py-1 rounded-full mb-3">
            探索内容
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            选择你感兴趣的主题
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto">
            从基础入门到进阶技法，从风味创作到创业实战，找到最适合你的学习路径
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex items-start gap-4 p-6 rounded-2xl transition-all duration-300 cursor-pointer ${colors.bg}`}
              >
                <div
                  className={`w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 ${colors.iconBg}`}
                >
                  <i className={`${cat.icon} text-xl text-background-50`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className={`font-heading text-lg font-semibold mb-1 ${colors.text}`}>
                    {cat.name}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                    {cat.description}
                  </p>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-500">
                    {cat.articleCount} 篇文章
                    <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
                  </span>
                </div>
              </Link>
            );
          })}
          <Link
            to="/about"
            className="group flex items-start gap-4 p-6 rounded-2xl bg-background-100/80 hover:bg-background-100 transition-all duration-300 cursor-pointer"
          >
            <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0 bg-foreground-700">
              <i className="ri-building-2-fill text-xl text-background-50"></i>
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="font-heading text-lg font-semibold text-foreground-800 mb-1">
                关于黄油作坊
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                了解我们的品牌故事、团队理念与联系方式
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-medium text-foreground-500">
                了解更多
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform"></i>
              </span>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
}